import React from "react";
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay, Navigation, Pagination} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./HeroSection.css";
import {useNavigate} from "react-router-dom";

const slides = [
  {
    id: 1,
    title: "Get a loan with your Jewelries",
    description:
      "We accept any form of high-end jewelry whether it’s a necklace or bracelet made in diamond or gold.",
    strong: "50% loan to value.",
    background: "/assets/images/slider/slider-1.jpeg",
  },
  {
    id: 2,
    title: "Get a loan with your Cars",
    description: "We accept different models of cars from 2007.",
    strong: "50% loan to value.",
    background: "/assets/images/slider/slider-2.jpeg",
  },
  {
    id: 3,
    title: "Get a loan with your Luxury Watches",
    description: "We accept Rolex, Audemars Piguet, Patek Philippe, etc.",
    strong: "50% loan to value.",
    background: "/assets/images/slider/slider-3.jpeg",
  },
];

const HeroSection = () => {
  const navigate = useNavigate()
  return (
    <Swiper
      modules={[Navigation, Pagination, Autoplay]}
      navigation
      pagination={{ clickable: true }}
      autoplay={{ delay: 5000 }}
      loop
      className="hero-swiper"
      id="home"
    >
      {slides.map((slide) => (
        <SwiperSlide key={slide.id}>
          <div
            className="hero-slide"
            style={{ backgroundImage: `url(${slide.background})` }}
          >
            <div className="hero-overlay">
              <div className="hero-content">
                <h1>
                  {slide.title.split("with your")[0]} <br />
                  <span>{slide.title.split("with your")[1]}</span>
                </h1>
                <p>
                  {slide.description} <b>{slide.strong}</b>
                </p>
                <button className="hero-button" onClick={() => {
                  navigate('/contact-us')
                }}>
                    Get Started
                  </button>
              </div>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default HeroSection;
